// eslint-disable-next-line import/prefer-default-export
export function getSlotContent(slot) {
  if (!slot) {
    return null;
  }

  const slotContent = typeof slot === 'function' ? slot() : slot;

  if (!slotContent) {
    return null;
  }

  if (!Array.isArray(slotContent)) {
    return null;
  }

  if (slotContent.length === 0) {
    return null;
  }

  return slotContent;
}
